import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { CONTACT } from 'config/contact';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-surface border border-border rounded-full px-4 py-2 mb-6">
            <Icon name="Zap" size={16} className="text-accent" />
            <span className="text-sm font-medium text-text-secondary">
              Communication Automation Excellence
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight">
            WhatsApp & Email Automation That{' '}
            <span className="text-primary">Converts</span>
          </h1>

          <p className="text-lg sm:text-xl text-text-secondary mb-8 max-w-3xl mx-auto">
            Transform your communication workflows with intelligent WhatsApp Business API and email automation. Respond instantly, nurture leads automatically, and reclaim 40-70 hours monthly.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link to="/contact">
              <Button variant="default" size="lg" iconName="Calendar" iconPosition="left">
                Book Free Automation Audit
              </Button>
            </Link>
            <a href={CONTACT.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" size="lg" iconName="MessageCircle" iconPosition="left">
                Chat on WhatsApp
              </Button>
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-8 items-center">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={20} className="text-success" />
              <span className="text-sm text-text-secondary">99.9% Uptime</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={20} className="text-success" />
              <span className="text-sm text-text-secondary">24/7 Automation</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="TrendingUp" size={20} className="text-success" />
              <span className="text-sm text-text-secondary">3x Response Rate</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;